export const CHART_COLORS = [
  '#00e17f',
  '#f27a00',
  '#005173',
  '#00c2e0',
  '#17305d',
  '#82e1f2',
  '#a09400',
  '#f3a500',
  '#ce4569',
  '#f2d600',
  '#0096ad',
  '#7a849c',
  '#008030',
  '#f2eb42',
  '#1bb563',
  '#b92750',
  '#bbbc00',
  '#f6dbe3',
  '#007797',
  '#bef5d3',
  '#494e5d',
];

export default function getChartColor(chartDataIndex: number) {
  return CHART_COLORS[chartDataIndex % CHART_COLORS.length];
}
